import React, { useEffect, useState } from "react";
import "../../styles/desktop/status.css";

export default function Status() {
  const [userName, setUserName] = useState("Guest");
  const [status, setStatus] = useState("Verificando");
  const version = process.env.REACT_APP_VERSION || "???"; // Versão da aplicação
  useEffect(() => {
    const sessionData = sessionStorage.getItem("user");
    if (sessionData) {
        const user = JSON.parse(sessionData);
        let name = user.name || "Guest";
    
        // Mantém apenas o primeiro nome
        name = name.split(" ")[0];
    
        // Abrevia se exceder 20 caracteres
        if (name.length > 20) {
          name = `${name.substring(0, 20)}...`;
        }
    
        setUserName(name);
    }

    // Cria um WebSocket para monitorar conectividade
    let socket;
    const checkConnectivity = () => {
      try {
        socket = new WebSocket("wss://echo.websocket.org"); // WebSocket de teste
        socket.onopen = () => setStatus("Online");
        socket.onerror = () => setStatus("Offline");
        socket.onclose = () => setStatus("Offline");
      } catch {
        setStatus("Offline");
      }
    };

    checkConnectivity(); // Verifica ao carregar o componente

    // Intervalo para manter a conexão viva (ping)
    const interval = setInterval(() => {
      if (socket && socket.readyState !== WebSocket.OPEN) {
        checkConnectivity();
      }
    }, 3000);

    return () => {
      clearInterval(interval); // Limpa o intervalo ao desmontar
      if (socket) socket.close(); // Fecha o WebSocket
    };
  }, []);

  const statusClass = status === "Online" ? "status-online" : status === "Offline" ? "status-offline" : "";

  return (
    <div className="statusContent">
      <p>
        <strong>User:</strong> {userName}
      </p>
      <p>
        <strong>Status:</strong> <span className={statusClass}>{status}</span>
      </p>
      <p>
        <strong>Version:</strong> {version}
      </p>
    </div>

  );
}
